import React from 'react';
import { Alert } from '@paysera/react-common';

import { BackLink } from './component/BackLink';
import { VacancyDescription } from './component/VacancyDescription';
import { VacancyDetails } from './component/VacancyDetails';
import { CountryDropdown, Spinner } from '../shared/components';
import { mapCountries } from '../shared/utils';
import { replaceTags } from './utils';
import { mapCountryCode } from './utils/mapCountryCode';
import { getCustomField } from './utils/vacancies';
import { useGetVacancy } from './hooks/useGetVacancy';

const VacancyOffer = () => {
    const {
        vacancy,
        loading,
        error,
        refetch,
    } = useGetVacancy();

    const vacancyCountries = getCustomField(vacancy, 'countries');
    const availableCountries = vacancyCountries?.filter(Boolean).map(mapCountryCode)

    if (error) {
        return <Alert bsStyle="danger">{error}</Alert>;
    }

    return (
        <div className="container vacancy-offer-container">
            {loading && <Spinner />}
            <BackLink />
            <div className="row">
                <h1 className="featured-heading col-sm-8">
                    <strong>{vacancy?.title}</strong>
                </h1>
                <div className="col-sm-4">
                    {!!availableCountries?.length && (
                        <CountryDropdown
                            onCountryChange={refetch}
                            availableCountries={availableCountries}
                        />
                    )}
                </div>
            </div>

            {vacancy && (
                <div className="row">
                    <div className="col-sm-8">
                        <VacancyDescription
                            description={replaceTags(vacancy?.description ?? '')}
                            whatWeOffer={vacancy?.what_we_offer}
                            forCandidates={vacancy?.for_candidates}
                        />
                    </div>
                    <div className="col-sm-4">
                        <VacancyDetails
                            locations={mapCountries(vacancyCountries)}
                            salary={vacancy?.salary_info}
                            bonuses={getCustomField(vacancy, 'bonuses')}
                            jobLevel={vacancy?.job_level}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default VacancyOffer;
